/* assets/mezuzah-share-row.js
   MEZUZAH-OWNED FILE (see docs/SYSTEM-MAP.md). WO-657 item 9: the copy link button of snippets/mezuzah-share-row.liquid.
   Copies the button's data-share-url, then shows the theme's own "Link copied to clipboard" message (already in the
   button group, hidden) for two seconds. Delegated on the document so several rows or a re-rendered section still work,
   and guarded so loading the file twice binds once. */
(function () {
  if (window.__mzShareRowBound) return;
  window.__mzShareRowBound = true;

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(field);
      ok ? resolve() : reject(new Error('copy failed'));
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target && typeof event.target.closest === 'function' ? event.target.closest('[data-mz-share-copy]') : null;
    if (!button) return;
    var group = button.closest('.mz-share');
    var message = group ? group.querySelector('[data-mz-share-msg]') : null;
    copyText(button.getAttribute('data-share-url') || window.location.href).then(function () {
      if (!message) return;
      message.classList.add('is-visible');
      setTimeout(function () { message.classList.remove('is-visible'); }, 2000);
    }).catch(function () {});
  });
})();
